import { REPORT_TYPE_IDS } from "../../../store/constants";
import AnnualDataQuality from "./AnnualDataQuality";

const AnnualVolumeForecast = () => (
  <AnnualDataQuality
    reportTypeId={REPORT_TYPE_IDS.annual_volume_throughput_demand_forecast}
    title="Annual Volume, Throughput, and Demand Forecast"
    description="Annual demand seasonality, throughput, branch/service rankings, peak periods, and forecast baseline."
    emptyDataMessage="Annual Volume and Forecast data is empty for the selected year."
    searchPrompt="Update filters and hit Search to retrieve annual Volume and Forecast data."
  />
);

export default AnnualVolumeForecast;
